import script from "./WithdrawConfigV3.vue?vue&type=script&lang=ts&setup=true"
export * from "./WithdrawConfigV3.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__